import React from "react";
import "./index.scss";
import { logOut } from "../../services/authentication";


const UserBanner = ({ guardData }) => {
    return <div id="userBanner" className={`w-100 mx-auto row bg-primary shadow-lg px-4 d-flex align-items-center py-2 text-white`}>
        <div className="col-md-6">
            ¡Hola <strong>{guardData.name || guardData.email}</strong>!
        </div>
        <div className="col-md-6 text-right">
            {!guardData.institucional ?
                <a className="btn btn-primary text-white border-white mt-2 mb-2" href="/dashboard/orders">Ir al dashboard&nbsp;<em className="fas fa-chevron-right " /></a> :
                <button className="btn btn-primary text-white border-white mt-2 mb-2" onClick={() => logOut("/login")}><i className="fas fa-sign-out-alt pointer fa-lg text-white" />&nbsp;Cerrar sesión</button>
            }
        </div>

    </div>
};

export default UserBanner;